<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-calendar heroicon heroicon-sm"
  >
    <rect
      class="heroicon-calendar-month heroicon-component-fill"
      width="60"
      height="48"
      y="12"
      fill="#FFFFFF"
    ></rect>
    <path
      class="heroicon-calendar-binding heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M48 3h12v9H0V3h12v3a2 2 0 0 0 2 2 2 2 0 0 0 2-2V3h28v3a2 2 0 0 0 2 2 2 2 0 0 0 2-2V3z"
    ></path>
    <rect
      class="heroicon-calendar-date heroicon-component-accent heroicon-component-fill"
      width="8"
      height="7"
      x="40"
      y="30"
      fill="#7ACFC0"
    ></rect>
    <path
      class="heroicon-calendar-rings heroicon-component-fill"
      fill="#FFFFFF"
      d="M12 2a2 2 0 0 1 2-2 2 2 0 0 1 2 2v4a2 2 0 0 1-2 2 2 2 0 0 1-2-2V2zm32 0a2 2 0 0 1 2-2 2 2 0 0 1 2 2v4a2 2 0 0 1-2 2 2 2 0 0 1-2-2V2z"
    ></path>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M0 51h60v9H0v-9zM0 9h60v5H0V9z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M14 0a2 2 0 0 1 2 2v1h28V2a2 2 0 1 1 4 0v1h12v57H0V3h12V2c0-1.1.9-2 2-2zm1 6V2a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm1-1v1a2 2 0 1 1-4 0V5H2v4h56V5H48v1a2 2 0 1 1-4 0V5H16zm31 1V2a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm11 45V13H2v38h56zm0-40v-1H2v1h56zM2 56h20v1H2v1h56v-1H47v-1h11v-1H39v-1h19v-1H2v1h15v1H2v1zm11-38v6h6v-6h1v6h6v-6h1v6h6v-6h1v6h6v-6h1v6h6v-6h1v6h8v1h-8v5h8v1h-8v5h8v1h-8v5h8v1h-8v6h-1v-6h-6v6h-1v-6h-6v6h-1v-6h-6v6h-1v-6h-6v6h-1v-6h-6v6h-1v-6H4v-1h8v-5H4v-1h8v-5H4v-1h8v-5H4v-1h8v-6h1zm34 24v-5h-6v5h6zm-7 0v-5h-6v5h6zm-7 0v-5h-6v5h6zm-7 0v-5h-6v5h6zm-7 0v-5h-6v5h6zm28-6v-5h-6v5h6zm-7 0v-5h-6v5h6zm-7 0v-5h-6v5h6zm-7 0v-5h-6v5h6zm-7 0v-5h-6v5h6zm28-6v-5h-6v5h6zm-7 0v-5h-6v5h6zm-7 0v-5h-6v5h6zm-7 0v-5h-6v5h6zm-7 0v-5h-6v5h6zm23 8h1v1h-1v-1zm-6 0v1h-1v-1h1zm-7 0v1h-1v-1h1zm-7 0v1h-1v-1h1zm-7 0v1h-1v-1h1zm28-6v1h-1v-1h1zm-7 0v1h-1v-1h1zm-7 0v1h-1v-1h1zm-7 0v1h-1v-1h1zm-7 0v1h-1v-1h1zm28-6v1h-1v-1h1zm-7 0v1h-1v-1h1zm-7 0v1h-1v-1h1zm-7 0v1h-1v-1h1zm-7 0v1h-1v-1h1zm20-6h1v1h-1v-1zm7 0h1v1h-1v-1zm7 0h1v1h-1v-1zM7 26h1v1H7v-1zm43 0v1h-1v-1h1zM8 32v1H7v-1h1zm41 0h1v1h-1v-1zM7 38h1v1H7v-1zm43 0v1h-1v-1h1zM8 44v1H7v-1h1zm7 0v1h-1v-1h1zm7 0v1h-1v-1h1zm7 0v1h-1v-1h1zm7 0v1h-1v-1h1zm7 0v1h-1v-1h1zm7 0v1h-1v-1h1z"
    ></path>
  </svg>
</template>
